export const LEAD_IMAGE_POSITION = {
  max: 5,
  min: 1,
} as const;
